// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inform{
height: 2rem;
width: 25vw;
margin-left: 1rem;
}

.checkbox {
   height: 1.5rem;
   width: 1.5rem;
};

.checkbox__checked {
    background-color: blue;
  };

.table1{
    font-size: small;
    display: flex;
  }

  thead{
    text-align: center;
    word-wrap: normal;
  }
  tbody{
    text-align: center;
    word-wrap: normal;
  }

  tr{
    font-size: small;
    border: 5px transparent solid;
   
  }
 td{
    border-top: 1px solid black;
    border: 8px solid transparent;
    word-wrap: normal;
 }
 .spclbtn{
    color: rgb(255, 81, 0);
    border: 1px  rgb(255, 81, 0) solid;
    border-radius: 4px;    
}

.spclbtn:hover{
    background-color:  rgb(255, 81, 0);
    color: white;
}

.midheader{
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: end;
  height: 16rem;
}

.midheadersibling{
  display: grid;
    border: none;
    border-radius: 20px;
    padding: 20px;
    background-color: pink;
    position: relative;
    bottom: 12.5rem;
}
@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-expand 0.5s ease-in-out;
  }
}

@keyframes App-logo-expand {
  from {
    width: 0; /* start with no width */
    opacity: 0; /* start with no opacity */
    scale: 0;
  }
  to {
    width: 100%; /* expand to full width */
    opacity: 1; /* fully visible */
    scale: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/page.css"],"names":[],"mappings":"AAAA;AACA,YAAY;AACZ,WAAW;AACX,iBAAiB;AACjB;;AAEA;GACG,cAAc;GACd,aAAa;AAChB,CAAA;;AAEA;IACI,sBAAsB;EACxB,CAAA;;AAEF;IACI,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;;EAE/B;CACD;IACG,2BAA2B;IAC3B,6BAA6B;IAC7B,iBAAiB;CACpB;CACA;IACG,sBAAsB;IACtB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;AACA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,QAAQ,EAAE,wBAAwB;IAClC,UAAU,EAAE,0BAA0B;IACtC,QAAQ;EACV;EACA;IACE,WAAW,EAAE,yBAAyB;IACtC,UAAU,EAAE,kBAAkB;IAC9B,WAAW;EACb;AACF","sourcesContent":[".inform{\nheight: 2rem;\nwidth: 25vw;\nmargin-left: 1rem;\n}\n\n.checkbox {\n   height: 1.5rem;\n   width: 1.5rem;\n};\n\n.checkbox__checked {\n    background-color: blue;\n  };\n\n.table1{\n    font-size: small;\n    display: flex;\n  }\n\n  thead{\n    text-align: center;\n    word-wrap: normal;\n  }\n  tbody{\n    text-align: center;\n    word-wrap: normal;\n  }\n\n  tr{\n    font-size: small;\n    border: 5px transparent solid;\n   \n  }\n td{\n    border-top: 1px solid black;\n    border: 8px solid transparent;\n    word-wrap: normal;\n }\n .spclbtn{\n    color: rgb(255, 81, 0);\n    border: 1px  rgb(255, 81, 0) solid;\n    border-radius: 4px;    \n}\n\n.spclbtn:hover{\n    background-color:  rgb(255, 81, 0);\n    color: white;\n}\n\n.midheader{\n  position: relative;\n  z-index: 5;\n  display: flex;\n  justify-content: end;\n  height: 16rem;\n}\n\n.midheadersibling{\n  display: grid;\n    border: none;\n    border-radius: 20px;\n    padding: 20px;\n    background-color: pink;\n    position: relative;\n    bottom: 12.5rem;\n}\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-expand 0.5s ease-in-out;\n  }\n}\n\n@keyframes App-logo-expand {\n  from {\n    width: 0; /* start with no width */\n    opacity: 0; /* start with no opacity */\n    scale: 0;\n  }\n  to {\n    width: 100%; /* expand to full width */\n    opacity: 1; /* fully visible */\n    scale: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
